import { FETCH_USER_SUMMARY_REQUEST, FETCH_USER_SUMMARY_SUCCESS, FETCH_USER_SUMMARY_ERROR } from '../constants/ActionTypes'
import type { Dispatch } from 'redux'
import { UserSummary } from 'app/types/userSummary.types'

function fetchUserSummaryRequest() {
    return {
        type: FETCH_USER_SUMMARY_REQUEST,
    }
}

function fetchUserSummarySuccess(data: UserSummary | undefined) {
    return {
        type: FETCH_USER_SUMMARY_SUCCESS,
        payload: data,
    }
}

function fetchUserSummaryError(error: any) {
    return {
        type: FETCH_USER_SUMMARY_ERROR,
        error,
    }
}

export default function fetchUserSummary() {
    return async (dispatch: Dispatch) => {
        dispatch(fetchUserSummaryRequest())

        try {
            const userSummary: UserSummary | undefined = await window?.SF?.getUserSummary()

            dispatch(fetchUserSummarySuccess(userSummary))
        } catch (error) {
            dispatch(fetchUserSummaryError(error))
        }
    }
}
